// extracted by mini-css-extract-plugin
export default {"expired":"MatchCountCell_expired__zCi8r"};